/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CSVUpload.vue?vue&type=template&id=4d519820&scoped=true&"
import script from "./CSVUpload.vue?vue&type=script&lang=js&"
export * from "./CSVUpload.vue?vue&type=script&lang=js&"
import style0 from "./CSVUpload.vue?vue&type=style&index=0&id=4d519820&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d519820",
  null
  
)

export default component.exports